import axios from 'axios';
import { defaultTo } from 'ramda';
import { fulfilled, rejected, pending } from '../utils/helpers';
import { Precision, Compare } from '../constants';

export const types = {
  FETCH_CITY_CRIMES: 'FETCH_CITY_CRIMES',
  FETCH_CENSUS_CRIMES: 'FETCH_CENSUS_CRIMES',
};

// FIXME: data.data
export const fetchCrimes = (cityId, timespans, precision, compare, crimeType) =>
  cityId
    ? {
        type: types.FETCH_CENSUS_CRIMES,
        // TODO: real API request
        payload: axios
          .post('/censusCrimes', {
            cityId,
            timespans,
            yearData: precision === Precision.YEARLY,
            incompleteAllowed:
              [Compare.RECURRING, Compare.NONE].indexOf(compare) >= 0,
            crimeType,
          })
          .then(response => response.data.data),
      }
    : {
        type: types.FETCH_CITY_CRIMES,
        payload: axios
          .post('/crimes', {
            cityId,
            timespans,
            yearData: precision === Precision.YEARLY,
            incompleteAllowed:
              [Compare.RECURRING, Compare.NONE].indexOf(compare) >= 0,
            crimeType,
          })
          .then(response => response.data.data),
      };

export const initialState = {
  values: {},
  pending: false,
};

const getCrimesReducer = actionType => (
  state = initialState,
  { type, payload },
) => {
  switch (type) {
    case pending(actionType):
      return {
        ...state,
        values: initialState.values,
        pending: true,
      };

    case fulfilled(actionType):
      return {
        ...state,
        values: defaultTo(initialState.values, payload),
        pending: false,
      };

    case rejected(actionType):
      return {
        ...state,
        pending: false,
      };

    default:
      return state;
  }
};

export const censusCrimes = getCrimesReducer(types.FETCH_CENSUS_CRIMES);
export const cityCrimes = getCrimesReducer(types.FETCH_CITY_CRIMES);

export const getCityCrimes = state => state.cityCrimes.values;
export const getCensusCrimes = state => state.censusCrimes.values;
export const getCityCrimesPending = state => state.cityCrimes.pending;
export const getCensusCrimesPending = state => state.censusCrimes.pending;



// WEBPACK FOOTER //
// ./src/reducers/crimes.js